export const legacyArchiveKeys = {
  list: (memberId: string) => ['legacyTripArchive', 'list', memberId] as const,
  detail: (tripId: string, memberId: string) => ['legacyTripArchive', 'detail', tripId, memberId] as const,
}
